import { render, staticRenderFns } from "./ChannelDetail.vue?vue&type=template&id=ff23d9a8&scoped=true&"
import script from "./ChannelDetail.vue?vue&type=script&lang=js&"
export * from "./ChannelDetail.vue?vue&type=script&lang=js&"
import style0 from "./ChannelDetail.vue?vue&type=style&index=0&id=ff23d9a8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff23d9a8",
  null
  
)

export default component.exports